module.exports = __webpack_public_path__ + "img/common-popup.b90eb9bf.png";